import { IconUser } from '@tabler/icons-react'

import { AstraIcon, AstraParagraph, astraTwMerge } from '~/astra'

const PlaceholderMessage = ({ className }: { className?: string }) => (
    <div className={astraTwMerge('rounded-xl border border-strong bg-surface-base p-3', className)} aria-hidden>
        <div className="flex items-start justify-between gap-4">
            <div className="flex items-center gap-3">
                <div className="flex h-6 w-6 items-center justify-center rounded-full bg-neutral-rest text-subtle">
                    <AstraIcon icon={IconUser} />
                </div>
                <div className="flex flex-col gap-1">
                    <div className="bg-border-subtle-rest h-3 w-28 rounded-full bg-neutral-subtle-rest" />
                </div>
                <div className="bg-border-subtle-rest/70 h-3 w-8 rounded-full bg-neutral-subtle-rest" />
            </div>
        </div>
        <div className="flex flex-col gap-2 pt-4">
            <div className="bg-border-subtle-rest/80 h-3 w-full rounded-full bg-neutral-subtle-rest" />
            <div className="bg-border-subtle-rest/70 h-3 w-11/12 rounded-full bg-neutral-subtle-rest" />
        </div>
    </div>
)

export const EmptyCommentList = () => (
    <div className="relative flex w-full max-w-[460px] flex-col items-center justify-center px-4 py-12 text-center">
        <div className="relative min-w-[250px] -rotate-6">
            <PlaceholderMessage className="relative z-[10]" />
            <div className="absolute inset-0 -translate-x-3 translate-y-3 rounded-xl border border-subtle bg-surface-base opacity-90 shadow-sm" />
            <div className="absolute inset-0 -z-elevated -translate-x-6 translate-y-6 rounded-xl border border-subtle bg-surface-base opacity-80 shadow-sm" />
        </div>
        <AstraParagraph className="pt-16 text-muted">Ingen kommentarer enda.</AstraParagraph>
    </div>
)
